import { NgIf } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';

/** What a host shows in its one app-confirm-dialog, and what runs once it closes. */
export interface ConfirmDialogRequest
{
    heading: string;
    message?: string;
    html?: string;
    danger?: string;
    confirmLabel: string;
    cancelLabel?: string;
    destructive?: boolean;
    hideCancel?: boolean;
    onClose: (confirmed: boolean) => void;
}

/** A yes/no question on the kit dialog. Emits true to confirm, false on cancel, escape or the X. */
@Component({
    selector: 'app-confirm-dialog',
    standalone: true,
    imports: [NgIf],
    templateUrl: './confirm-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConfirmDialogComponent
{
    @Input() open = false;
    @Input() heading = '';
    @Input() message = '';
    @Input() confirmLabel = 'Confirm';
    @Input() cancelLabel = 'Cancel';
    @Input() icon = '';
    /** Red confirm button, for a delete or anything else that cannot be undone. */
    @Input() destructive = false;
    @Input() hideCancel = false;
    /** A second answer beside confirm, e.g. "No, share folder only"; picking it emits `secondary`, not `closed`. */
    @Input() secondaryLabel = '';
    @Output() closed = new EventEmitter<boolean>();
    @Output() secondary = new EventEmitter<void>();
}
